import { FC } from 'react'
import { RewardsFilter } from 'interfaces/bounty'
import RewardDetailsTabsMobile from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabsMobile'
import RewardDetailsTabsDesktop from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabsDesktop'
import { WithMobileProps } from 'hocs/withMobile/withMobile'

export type RewardDetailsTabsStateProps = {
  active: RewardsFilter
}

export type RewardDetailsTabsOwnProps = {
  zeroState?: boolean
}

export type RewardDetailsTabsDispatchProps = {
  onTabClick: (filter: RewardsFilter) => void
}

export type RewardDetailsTabsProps =
  & WithMobileProps
  & RewardDetailsTabsStateProps
  & RewardDetailsTabsDispatchProps

const RewardDetailsTabs: FC<RewardDetailsTabsProps> = (props) => {
  const { isMobile } = props

  const Component = isMobile ? RewardDetailsTabsMobile : RewardDetailsTabsDesktop

  return (
    <Component { ...props } />
  )
}

export default RewardDetailsTabs
